import styled from 'styled-components'

export default styled.div`
  cursor: pointer;
  display: flex;
  min-height: 48px;
  min-width: 48px;
  padding: 0;
  justify-content: center;
  border: none;
  user-select: none;

  background-color: #ffffff;
  background-position: center;
  background-repeat: no-repeat;

  border-radius: 50%;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08);
`
